import { z } from 'zod';

export const referralClaimRequestSchema = z.object({
  referrerId: z.number().int().positive(),
});
export type ReferralClaimRequest = z.infer<typeof referralClaimRequestSchema>;

export const referralClaimResponseSchema = z.object({
  claimed: z.boolean(),
});
export type ReferralClaimResponse = z.infer<typeof referralClaimResponseSchema>;

export const referralInfoResponseSchema = z.object({
  link: z.string().url(),
  invitedCount: z.number().int().nonnegative(),
  rewardedCount: z.number().int().nonnegative(),
  rewardCredits: z.number().int().nonnegative(),
});
export type ReferralInfoResponse = z.infer<typeof referralInfoResponseSchema>;
